import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@coin/shared/core/util-environments';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EquityDocumentsService {
  private readonly http = inject(HttpClient);

  getFileKeysByFolder(folderPath: string): Observable<string[]> {
    return this.http.get<string[]>(`${environment.api.documentsUrl}/equity-documents/list/${folderPath}`);
  }

  getFileDownloadUrl(data: { key: string; folderPath: string }): Observable<string> {
    return this.http.post<string>(`${environment.api.documentsUrl}/equity-documents`, {
      key: data.folderPath ? data.folderPath + data.key : data.key
    });
  }
}
